// 首页相关api
import request from '../index'

/**
 * 获取视频类型
 * @returns 
 */
export const GetTypeList = (data) => {
  return request({
    url: '/system/dict/data/',
    method: 'get',
    params: data
  });
}
/**
 * 获取模板列表视频
 * @returns 
 */
export const GetVideoList = (data) => {
  return request({
    url: '/material/info/',
    method: 'get',
    params: data
  });
}
/**
 * 上传头像
 * @returns 
 */
export const addHead = (data) =>{
  return request({
    url: '/user/head/info/',
    method: 'post',
    data
  });
}
export const getHeadList = (data) => {
  return request({
    url: '/user/head/info/?s=3',
    method: 'get'
  });
}
export const submit = (data) =>{
  return request({
    url: '/material/info/swapManyFace',
    method: 'post',
    data
  });
}
export const getVideoStatus = (data) =>{
  return request({
    url: '/material/info/getSwapStatus',
    method: 'post',
    data
  });
}
export const getVideoUrlV1 = (data) =>{
  return request({
    url: '/material/info/getSwapResult',
    method: 'post',
    data
  });
}
/**
 * 保存视频
 * @returns 
 */
export const getDownVideoV1 = (data) =>{
  return request({
    url: '/material/info/saveSwapVideo',
    method: 'post',
    data
  });
}
/**
 * 分页查询会员上传的视频
 * @returns 
 */
export const GetlistMemberVideo = (data) => {
  return request({
    url: '/material/info/listMemberVideo',
    method: 'get',
    params: data
  });
}
/**
 * 分享视频和图片
 * @returns 
 */
export const shareFile = (data) =>{
  return request({
    url: '/material/info/share/'+data,
    method: 'get'
  });
}
/**
 * 获取我的视频和图片
 * @returns 
 */
export const getMyVideo = (data) => {
  return request({
    url: '/user/video/info/',
    method: 'get',
    params: data
  });
}
/**
 * 计算换脸需要消耗的积分
 * @returns 
 */
export const getVideoNeedCredits = (data) =>{
  return request({
    url: '/material/info/computeSwapPoints/'+data,
    method: 'get'
  });
}
/**
 * 获取上传文件时候的状态
 * @returns 
 */
export const getUploadDetail = (data) =>{
  return request({
    url: '/app/material/batch/upload/detail/'+data,
    method: 'get'
  });
}
/**
 * 获取上传文件时候的状态
 * @returns 
 */
export const getMaterialDetail = (data) =>{
  return request({
    url: '/material/info/'+data,
    method: 'get'
  });
}
/**
 * 举报
 * @returns 
 */
export const reportInfo = (data) =>{
  return request({
    url: '/material/report/info/',
    method: 'post',
    data
  });
}